let resources = []

resources = resources.concat([
    require("@frog/source/assets/images/bomber-tactics/loading.png").default,
])

import units from "@frog/source/data/units.js"
Object.values(units).forEach((unit) => {
    Object.values(unit.images.sprites).forEach((sprite) => {
        if(sprite instanceof Array) {
            resources = resources.concat(sprite.map((frame) => frame.image))
        } else if(sprite.frames != undefined) {
            resources = resources.concat(sprite.frames.map((frame) => frame.image))
        } else {
            resources.push(sprite)
        }
    })
})

import encounters from "@frog/source/data/encounters/encounters.js"
resources = resources.concat(Object.values(encounters["level1"].stage.world.tileset.tiles).map((tile) => tile.imageSource))

const animations = [
    require("@frog/source/assets/images/bomber-tactics/title/screen/animation.js"),
    require("@frog/source/assets/images/bomber-tactics/title/start/animation.js")
].forEach((anim) => {
    resources = resources.concat(anim.frames.map((frame) => frame.image))
})

resources = resources.concat([
    require("@frog/source/assets/images/bomber-tactics/arrow/south-start.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/east-start.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/west-start.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/north-start.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/south-end.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/east-end.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/west-end.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/north-end.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/north-south.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/south-west.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/south-east.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/east-west.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/north-east.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/south-east.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/east-west.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/north-west.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/south-west.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/north-south.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/north-west.png").default,
    require("@frog/source/assets/images/bomber-tactics/arrow/north-east.png").default,
    require("@frog/source/assets/images/bomber-tactics/tile-threat.png").default,
    require("@frog/source/assets/images/bomber-tactics/unit-bomb.png").default,
    require("@frog/source/assets/images/bomber-tactics/ui/done-button.png").default,
    require("@frog/source/assets/images/bomber-tactics/ui/undo-button.png").default,
    require("@frog/source/assets/images/bomber-tactics/level-clear.png").default,
    require("@frog/source/assets/images/bomber-tactics/game-over.png").default,
    require("@frog/source/assets/images/bomber-tactics/credits-screen.png").default,
])

export default resources
